import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import BlogPostCard from '../Blog/BlogPostCard';
import { getRecentPosts } from '../../data/blogIndex';

const BlogHighlight = () => {
  const recentPosts = getRecentPosts(3);

  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="inline-flex items-center px-4 py-2 bg-cream rounded-full mb-6 border border-gray-100"
          >
            <span className="text-sm font-medium text-muted-grey">
              Latest Thinking
            </span>
          </motion.div>

          <h2 className="text-5xl md:text-6xl font-bold text-dark-slate mb-6 tracking-tight">
            From the
            <br />
            <span className="text-muted-blue-grey">Blog</span>
          </h2>

          <p className="text-xl text-muted-grey max-w-3xl mx-auto leading-relaxed">
            Perspectives on cloud strategy, AI adoption, and the future of enterprise technology
            from the front lines of digital transformation.
          </p>
        </motion.div>

        {/* Post Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {recentPosts.map((post, index) => (
            <BlogPostCard key={post.id} post={post} delay={index * 0.1} />
          ))}
        </div>

        {/* View All Link */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-center"
        >
          <Link to="/blog">
            <motion.span
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-white text-dark-slate rounded-full font-semibold text-lg border-2 border-gray-200 hover:border-gray-300 transition-all inline-block"
            >
              View All Articles
            </motion.span>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default BlogHighlight;
